import { CUSTOMER_JOURNEY_SERVICES_BOOK_SUCCESS } from './../const';

function action(data, successCallback) {
  return { type: CUSTOMER_JOURNEY_SERVICES_BOOK_SUCCESS, data, successCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyServicesBookSuccess.js